// src/pages/Login.js
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

function Login() {
  const [phone, setPhone] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const API_URL = 'https://boda-backend-wuea.onrender.com/api';

  useEffect(() => {
    localStorage.clear();
    sessionStorage.clear();
  }, []);

  const handleLogin = async (e) => {
    e.preventDefault();
    
    if (!phone || !password) {
      setError('Please enter phone number and password');
      return;
    }

    setLoading(true);
    setError('');

    try {
      localStorage.clear();
      sessionStorage.clear();
      
      const response = await axios.post(`${API_URL}/admin/login`, {
        phone_number: phone,
        password: password
      });

      console.log('🔐 Login Response:', response.data);

      if (response.data.success) {
        const userData = response.data.user || {};
        
        localStorage.setItem('token', response.data.token);
        
        const adminData = {
          id: userData.id,
          full_name: userData.full_name || 'Admin User',
          phone_number: userData.phone_number || phone,
          role: userData.role || userData.role_name || 'admin',
          role_name: userData.role_name || userData.role || 'admin',
          is_master: userData.is_master || false,
          permissions: userData.permissions || {},
        };
        
        console.log('✅ Storing Admin Data:', adminData);
        localStorage.setItem('admin', JSON.stringify(adminData));
        
        window.location.href = '/';
      } else {
        setError('Login failed: Invalid credentials');
      }
    } catch (err) {
      console.error('❌ Login error:', err);
      setError(err.response?.data?.error || 'Login failed. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      minHeight: '100vh',
      backgroundColor: '#f1f5f9',
      padding: '20px'
    }}>
      <div style={{
        backgroundColor: 'white',
        borderRadius: '16px',
        padding: '40px',
        width: '420px',
        maxWidth: '100%',
        boxShadow: '0 4px 6px rgba(0,0,0,0.1)'
      }}>
        <div style={{ textAlign: 'center', marginBottom: '30px' }}>
          <div style={{ fontSize: '48px', marginBottom: '10px' }}>🚗</div>
          <h1 style={{ margin: 0, color: '#1e293b' }}>Admin Login</h1>
          <p style={{ color: '#64748b', margin: '8px 0 0 0' }}>GoFurat Admin Dashboard</p>
        </div>

        {error && (
          <div style={{
            padding: '12px',
            backgroundColor: '#fee2e2',
            color: '#991b1b',
            borderRadius: '8px',
            marginBottom: '20px',
            fontSize: '14px',
            display: 'flex',
            alignItems: 'center',
            gap: '8px'
          }}>
            <span>⚠️</span> {error}
          </div>
        )}

        <form onSubmit={handleLogin}>
          <div style={{ marginBottom: '16px' }}>
            <label style={{
              display: 'block',
              marginBottom: '8px',
              color: '#64748b',
              fontWeight: '500'
            }}>
              Phone Number
            </label>
            <input
              type="tel"
              value={phone}
              onChange={(e) => setPhone(e.target.value)}
              placeholder="+256 700 000 000"
              style={{
                width: '100%',
                padding: '12px',
                borderRadius: '8px',
                border: '1px solid #e2e8f0',
                fontSize: '16px',
                boxSizing: 'border-box'
              }}
            />
          </div>

          <div style={{ marginBottom: '20px' }}>
            <label style={{
              display: 'block',
              marginBottom: '8px',
              color: '#64748b',
              fontWeight: '500'
            }}>
              Password
            </label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Enter your password"
              style={{
                width: '100%',
                padding: '12px',
                borderRadius: '8px',
                border: '1px solid #e2e8f0',
                fontSize: '16px',
                boxSizing: 'border-box'
              }}
            />
          </div>

          <button
            type="submit"
            disabled={loading}
            style={{
              width: '100%',
              padding: '14px',
              backgroundColor: '#f97316',
              color: 'white',
              border: 'none',
              borderRadius: '8px',
              fontSize: '16px',
              fontWeight: 'bold',
              cursor: loading ? 'not-allowed' : 'pointer',
              opacity: loading ? 0.7 : 1,
              transition: 'all 0.2s'
            }}
          >
            {loading ? 'Logging in...' : 'Login'}
          </button>
        </form>

        <div style={{
          marginTop: '20px',
          paddingTop: '20px',
          borderTop: '1px solid #e2e8f0',
          textAlign: 'center',
          fontSize: '12px',
          color: '#94a3b8'
        }}>
          <p>🔐 Secure Admin Access</p>
        </div>
      </div>
    </div>
  );
}

export default Login;